export default __webpack_public_path__ + "static/media/negroni.6ca41de9.jpg";